import { render } from "./StudentNavbar.vue?vue&type=template&id=23d797b2&scoped=true"
import script from "./StudentNavbar.vue?vue&type=script&lang=js"
export * from "./StudentNavbar.vue?vue&type=script&lang=js"

import "./StudentNavbar.vue?vue&type=style&index=0&id=23d797b2&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d797b2"]])

export default __exports__